import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';

export function JiraConfigExpiredBanner() {
  const { t } = useTranslation();

  return (
    <Alert
      severity='warning'
      sx={(theme) => ({
        border: '4px solid black',
        color: theme.palette.black.main,
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'nowrap',
        width: '100%',
        my: 3,
        p: 2,
        '& .MuiAlert-message': {
          flexShrink: 1,
          display: 'flex',
          alignItems: 'center',
          fontWeight: 700,
        },
      })}
    >
      {t('jiraConfigExpired')}
    </Alert>
  );
}
